import React, { useState, useEffect } from 'react';
import { MapPin, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Alert, AlertDescription } from './ui/alert';

const LocationPicker = ({ location, onLocationChange }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const getCurrentLocation = () => {
    setLoading(true);
    setError('');

    if (!navigator.geolocation) {
      setError('La geolocalización no está soportada en este navegador');
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        onLocationChange({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
        setLoading(false);
      },
      (err) => {
        setError('No se pudo obtener la ubicación. Por favor, verifica los permisos.');
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  return (
    <div className="space-y-3" data-testid="location-picker">
      <Button
        type="button"
        variant="outline"
        onClick={getCurrentLocation}
        disabled={loading}
        className="w-full"
        data-testid="get-location-button"
      >
        {loading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Obteniendo ubicación...
          </>
        ) : (
          <>
            <MapPin className="mr-2 h-4 w-4" />
            Capturar Ubicación GPS
          </>
        )}
      </Button>
      
      {error && (
        <Alert variant="destructive" data-testid="location-error">
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      
      {location && (
        <div className="text-sm text-gray-600 bg-green-50 border border-green-200 rounded-lg p-3" data-testid="location-display">
          <p className="font-medium text-green-800 mb-1">✓ Ubicación capturada</p>
          <p>Latitud: {location.lat.toFixed(6)}</p>
          <p>Longitud: {location.lng.toFixed(6)}</p>
        </div>
      )}
    </div>
  );
};

export default LocationPicker;